import './App.css';

import {Routes, Route} from 'react-router-dom';
import Login from "./Login";
import Signup from "./Signup";
import Profile from "./Profile";
import Projects from "./Projects";
import { RequireToken } from './Auth';
import LandingPage from './LandingPage';

function App() {
  return (
  <div className ="App">
  <meta httpEquiv="Content-Security-Policy" content="upgrade-insecure-requests"/>
    <Routes>
      <Route path="/" element = {<LandingPage/>}/>
      <Route path="/login" element = {<Login/>}/>
      <Route path="/signup" element = {<Signup/>}/>
      <Route path="/profile" element = {
        <RequireToken>
          <Profile/>
        </RequireToken>
      }/>
      <Route path="/projects" element = {
        <RequireToken>
          <Projects/>
        </RequireToken>
      }/>
   </Routes>
  </div>
  );
}

export default App;
